import React from 'react';

function PrivacyPolicy() {
    return (
        <div>
            <div className="p-6 max-w-4xl mt-32 mb-10 mx-auto font-cormorant">
                <h1 className="text-5xl text-center font-bold mb-8 text-black">Privacy Policy</h1>
                <p className="text-center mb-2 text-gray-700">Minacia Ltd</p>
                <p className="text-center mb-8 text-gray-700 italic">Effective Date: June 4th, 2025</p>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">1. Introduction</h2>
                    <p className="text-gray-700">
                        Minacia Ltd ("Minacia", "we", "our", "us") is a company registered in England and Wales under company number 15281270, with its registered office at 131 South End, Croydon, England, CR0 1BJ. We are committed to safeguarding the privacy of individuals whose personal data we process, including but not limited to clients, suppliers, partners, website users and other stakeholders.
                    </p>
                    <p className="mt-2 text-gray-700">
                        This Privacy Policy outlines how Minacia Ltd collects, uses, stores, transfers and discloses your personal data in compliance with the UK General Data Protection Regulation (UK GDPR), Data Protection Act 2018 and other applicable laws in England and Wales.
                    </p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">2. Scope of this Policy</h2>
                    <p className="text-gray-700 mb-2">This Privacy Policy applies to:</p>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li>Clients and prospective clients.</li>
                        <li>Business contacts and suppliers.</li>
                        <li>Individuals who interact with our company or employees.</li>
                        <li>Visitors to our physical premises and website.</li>
                        <li>Job applicants and employees (with supplemental internal policies).</li>
                    </ul>
                    <p className="mt-2 text-gray-700">
                        This policy does not apply to third-party websites, platforms or services linked to or from our systems or communications.
                    </p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">3. Lawful Basis for Processing</h2>
                    <p className="text-gray-700">Minacia Ltd will only process your personal data where a lawful basis applies, including:</p>
                    <ul className="list-disc list-inside ml-6 text-gray-700 mt-2">
                        <li><strong>Performance of a contract</strong> – where processing is necessary to fulfil a contract with you.</li>
                        <li><strong>Legal obligation</strong> – where we are required by law to process your data.</li>
                        <li><strong>Legitimate interests</strong> – where processing is necessary for our legitimate business interests and not overridden by your rights.</li>
                        <li><strong>Consent</strong> – where you have given us clear permission (e.g., for marketing).</li>
                        <li><strong>Vital interests</strong> – where processing is necessary to protect someone’s life (in rare situations).</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">4. Types of Personal Data We Collect</h2>
                    <p className="font-medium text-black">a. Identification & Contact Data</p>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li>Full name, title, date of birth.</li>
                        <li>Email address, phone number, postal address.</li>
                    </ul>
                    <p className="font-medium mt-4 text-black">b. Transactional & Financial Data</p>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li>Bank account or payment details.</li>
                        <li>Purchase history, billing and invoicing data.</li>
                    </ul>
                    <p className="font-medium mt-4 text-black">c. Professional & Employment Data</p>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li>Job title, employer, professional background.</li>
                    </ul>
                    <p className="font-medium mt-4 text-black">d. Technical & Usage Data</p>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li>IP address, browser type, device identifiers.</li>
                        <li>Usage information collected through cookies, analytics tools and server logs.</li>
                    </ul>
                    <p className="font-medium mt-4 text-black">e. Special Category Data (only when strictly necessary and with safeguards)</p>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li>Health or biometric data (e.g., for site access or recruitment).</li>
                        <li>Criminal records (for employee screening, where legally justified).</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">5. How We Collect Personal Data</h2>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li>Directly from you (e.g., email, phone, meetings, forms).</li>
                        <li>Via our website and social media interactions.</li>
                        <li>Through service providers and partners.</li>
                        <li>From public databases (e.g., Companies House).</li>
                        <li>Through recruitment agencies or referees.</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">6. How We Use Your Personal Data</h2>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li>Provide services to clients.</li>
                        <li>Manage our business relationships.</li>
                        <li>Process payments and financial records.</li>
                        <li>Respond to inquiries or support requests.</li>
                        <li>Improve and maintain our website, products and services.</li>
                        <li>Carry out recruitment and onboarding.</li>
                        <li>Ensure security and compliance with laws.</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">7. Sharing and Disclosing Personal Data</h2>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li>Service providers and suppliers.</li>
                        <li>Professional advisers.</li>
                        <li>Government authorities when legally required.</li>
                        <li>Business partners and affiliates.</li>
                        <li>Successors in title (e.g., mergers, acquisitions).</li>
                    </ul>
                    <p className="mt-2 text-gray-700">We ensure all third parties respect the security of your data and process it in accordance with the law.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">8. International Transfers</h2>
                    <p className="text-gray-700">We ensure appropriate safeguards when transferring data outside the UK, including:</p>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li>UK adequacy regulations</li>
                        <li>Standard Contractual Clauses (SCCs)</li>
                        <li>Binding corporate rules</li>
                    </ul>
                    <p className="mt-2 text-gray-700">You may request details by contacting our Data Protection Officer.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">9. Data Retention</h2>
                    <p className="text-gray-700">We retain personal data only as long as necessary. Factors influencing retention:</p>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li>Legal obligations</li>
                        <li>Contractual requirements</li>
                        <li>Nature and sensitivity of the data</li>
                    </ul>
                    <p className="mt-2 text-gray-700">Data is securely deleted or anonymised once no longer needed.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">10. Your Data Protection Rights</h2>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li>Right to access</li>
                        <li>Right to rectification</li>
                        <li>Right to erasure</li>
                        <li>Right to restriction</li>
                        <li>Right to object</li>
                        <li>Right to data portability</li>
                        <li>Right to withdraw consent</li>
                    </ul>
                    <p className="mt-2 text-gray-700">
                        Contact us at <a href="mailto:info@minaciasociety.com" className="text-black hover:underline">info@minaciasociety.com</a>. You may also complain to the <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer" className="text-black hover:underline">ICO</a>.
                    </p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">11. Security Measures</h2>
                    <p className="text-gray-700">We use encrypted data storage, secure authentication, audits, and staff training. While we strive for complete security, no system is 100% secure.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">12. Cookies and Tracking Technologies</h2>
                    <p className="text-gray-700">We use cookies to improve user experience, enable features, and analyze traffic. You can manage preferences through your browser or our cookie tool.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">13. Contact Information</h2>
                    <p className="text-gray-700">For questions, contact:</p>
                    <ul className="list-disc list-inside ml-6 text-gray-700">
                        <li><strong>Email</strong>: <a href="mailto:info@minaciasociety.com" className="text-black hover:underline">info@minaciasociety.com</a></li>
                        <li><strong>Phone</strong>: +44 20 3603 0603</li>
                        <li><strong>Address</strong>: 131 South End, Croydon, England, CR0 1BJ</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">14. Changes to This Privacy Policy</h2>
                    <p className="text-gray-700">We may update this policy. Changes will be posted with a revised “Effective Date.” We may notify you of significant updates via email.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-2xl font-semibold mb-2 text-black">15. Document Control and Compliance</h2>
                    <p className="text-gray-700">This policy is reviewed annually or upon legal/operational changes. It is formally approved by the Minacia Ltd management team.</p>
                </section>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
